import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import { DETAIL_MODE, FORM_TYPE_TEXT, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0 } from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { finalize } from "rxjs/operators";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_EDIT_ROUTE, PRIVATE_NURSERY_LIST_ROUTE, PRIVATE_NURSERY_MAP_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { TranslateService } from "@ngx-translate/core";
var NurseryDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryDetailComponent, _super);
    function NurseryDetailComponent(appComponent, router, location, genericService, nurseryManager, activeRoute, alertUtils, translate) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.translate = translate;
        _this.imageURL = null;
        _this.mode = DETAIL_MODE;
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_NAME", "name", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_ADDRESS", "address", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LAT", "latitude", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LONG", "longitude", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_VERSION_NUMBER", "versionNumber", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_VISIBLE", "visible", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0)
        ];
        _this.formInfo = new FormInfo(formInfoFields, null);
        _this.subscribeGenericServices();
        return _this;
    }
    NurseryDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.getNursery(params.id);
        });
    };
    NurseryDetailComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    NurseryDetailComponent.prototype.getNursery = function (id) {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.getNursery(id).pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function (nursery) {
            _this.nursery = nursery;
            if (_this.nursery.imageURL) {
                _this.imageURL = _this.nursery.imageURL;
            }
            else {
                _this.imageURL = null;
            }
            var values = {
                name: _this.nursery.name,
                address: _this.nursery.address,
                latitude: _this.nursery.latitude,
                longitude: _this.nursery.longitude,
                versionNumber: _this.nursery.versionNumber,
                visible: _this.nursery.visible === null || _this.nursery.visible ?
                    _this.translate.instant("YES") : _this.translate.instant("NO")
            };
            for (var _i = 0, _a = _this.formInfo.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                field.selectedValue = values[field.formControlName];
            }
            _this.formComponent.updateFormValues(_this.formInfo);
        });
    };
    NurseryDetailComponent.prototype.onEditNursery = function () {
        this.goToRouteByName(PRIVATE_NURSERY_EDIT_ROUTE, { id: this.nursery.uuid });
    };
    NurseryDetailComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE);
        });
    };
    NurseryDetailComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    NurseryDetailComponent.prototype.onSaveNursery = function () {
        // needed for aot compilation
    };
    NurseryDetailComponent.prototype.onOpenMap = function () {
        this.goToRouteByName(PRIVATE_NURSERY_MAP_ROUTE, { id: this.nursery.uuid });
    };
    NurseryDetailComponent.prototype.onFilesSelected = function (_) {
        // needed for aot compilation
    };
    return NurseryDetailComponent;
}(BaseComponent));
export { NurseryDetailComponent };
